import { h } from 'hyperapp'
import Close from './partials/close'
import { expressionValues, expressionPlaceholders } from '../utilities/expessions'

const Blocks = ({ click, change, expressions }) => (
    <nav class="blocks" role="navigation">
        {expressions.map(({ key, expression, value }) => (
            <div class="blocks-block">
                <span class="blocks-method">{expression}</span>
                {expressionValues.includes(expression) &&
                    <input type="text" class="blocks-input" value={value} onkeyup={(e) => change({ key, value: e.target.value })} onchange={(e) => change({ key, value: e.target.value })} placeholder={Object.keys(expressionPlaceholders).includes(expression) ? expressionPlaceholders[expression] : ''} />}
                <button type="button" class="blocks-button" onclick={() => click(key)}><Close /></button>
            </div>
        ))}
    </nav>
)

export default Blocks



// WEBPACK FOOTER //
// ./src/scripts/components/blocks.js